import React, { useCallback, useState } from "react";
import useHotkey from "hooks/useHotkey";
import NavIcon from "components/navigation/NavIcon";
import NavigationButton from "components/navigation/NavigationButton";
import QuickJumpModal from "./QuickJumpModal";
const QuickJumpModalContainer = () => {
  const [showQuickJumpModal, setShowQuickJumpModal] = useState(false);
  const toggleModal = useCallback(() => setShowQuickJumpModal((cur) => !cur), [setShowQuickJumpModal]);
  useHotkey({
    actionKey: "show-quick-jump-modal",
    callback: () => setShowQuickJumpModal(true),
    scope: "general"
  });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(NavigationButton, { "aria-label": "Open Quick Jump", id: "quickjump-search-nav", onClick: toggleModal }, /* @__PURE__ */ React.createElement(NavIcon, { type: "search", title: "Open Quick Jump" })), showQuickJumpModal && /* @__PURE__ */ React.createElement(QuickJumpModal, { onToggle: () => toggleModal() }));
};
export default QuickJumpModalContainer;
